import {injectable} from 'inversify'
import {IEndpointResolver} from '@/src/ports/services/api'
import {settings} from '@/src/config/settings'

@injectable()
export class NextApiEndpointProvider implements IEndpointResolver {
  resolve(path: string): string {
    return `${settings.NEXT_PUBLIC_FRONTEND_URL}${path}`
  }
}

@injectable()
export class ServerWebApiEndpointProvider implements IEndpointResolver {
  resolve(path: string): string {
    return `${settings.NEXT_PUBLIC_WEBAPI_ADDRESS}${path}`
  }
}